(function () {
  function initHeroSlider(sectionEl) {
    console.log('[HeroRebuild] Init called for section:', sectionEl);

    if (!window.Splide || !sectionEl) {
      console.warn('[HeroRebuild] Missing Splide or sectionEl');
      return;
    }

    const splideEl = sectionEl.querySelector('.hero-splide');
    if (!splideEl) {
      console.warn('[HeroRebuild] No .hero-splide element found');
      return;
    }

    // Destroy existing Splide instance if already mounted
    if (splideEl._splide) {
      splideEl._splide.destroy();
    }

    const autoplay = sectionEl.dataset.autoplay === 'true';
    const speed = parseInt(sectionEl.dataset.speed || '5000', 10);
    const showArrows = sectionEl.dataset.showArrows === 'true';
    const showDots = sectionEl.dataset.showDots === 'true';

    // Create Splide instance
    const splide = new Splide(splideEl, {
      type: 'fade',
      rewind: true,
      speed: 1000,
      autoplay: autoplay,
      interval: speed,
      pauseOnHover: true,
      arrows: showArrows,
      pagination: showDots,
      drag: true
    });

    // Mount Splide as soon as first image is ready
    const firstSlideImg = splideEl.querySelector('img.hero-slide__img');
    if (firstSlideImg && !firstSlideImg.complete) {
      firstSlideImg.addEventListener('load', () => {
        console.log('[HeroRebuild] First image loaded, mounting Splide');
        splide.mount();
      });
    } else {
      splide.mount();
    }
  }

  // === DOM READY (for live theme) ===
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.hero-slideshow-rebuild');
    if (sections.length === 0) {
      console.warn('[HeroRebuild] No .hero-slideshow-rebuild sections found');
      return;
    }
    sections.forEach(section => initHeroSlider(section));
  });

    // === SHOPIFY EDITOR SUPPORT ===
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.hero-slideshow-rebuild');
    if (section) {
      console.log('[HeroRebuild] Section loaded via editor');
      initHeroSlider(section);
    }
  });
})();
